import { useSelector } from "react-redux";
import classes from "./SubmmisionsTable.module.css"
import SubmmisionRow from "./SubmissionRow/Row";

const SubmmisionsTable = ({ currentAssessment, submissions, setSubmissionScore,assessments }) => {

    const texts = useSelector((state) => state.translate.texts);

    return (
        <div className={classes.SubmmissionList}>
            <div className={classes.SubmmissionTitle}>
                <div className={classes.CorrectAnswerTitle}>
                    <div className={classes.CorrectTitle}></div>
                    <div className={classes.Or}>/</div>
                    <div className={classes.InCorrectTitle}></div>
                </div>
                <div className={classes.NameTitle}> {texts.name}</div>
                <div className={classes.SolutionTitleWarp}>
                    <div className={classes.SolutionTitle}>{texts.answerLastTry}</div>
                </div>
                <div className={classes.PointsTitle}>{texts.score2}</div>
            </div>
            {submissions && submissions.map((submission, index) =>
                <SubmmisionRow
                    key={index}
                    currentAssessment={currentAssessment}
                    index={index}
                    submission={submission}
                    setSubmissionScore={setSubmissionScore}
                    submissions={submissions}
                    assessments={assessments}
                ></SubmmisionRow>
            )}
            <div className={classes.ViewAnswerLastTry}>{texts.viewAnswerLastTry}</div>
        </div >
    )
}
export default SubmmisionsTable